// 登录后（fetchCurrentUser 落库）若后端偏好与当前不同，对齐到后端偏好（跨设备一致）。
import { useEffect } from 'react'
import i18n from '@/i18n'
import { useAppSelector } from '@/store/hooks'
import { LOCALE_STORAGE_KEY, isAppLocale } from './locales'

export function LocaleSync() {
  const preferred = useAppSelector((s) => s.user.settings?.preferredLocale)
  useEffect(() => {
    if (isAppLocale(preferred) && preferred !== i18n.language) {
      void i18n.changeLanguage(preferred)
      localStorage.setItem(LOCALE_STORAGE_KEY, preferred)
    }
  }, [preferred])
  return null
}
